import { render, staticRenderFns } from "./WBtnArchive.vue?vue&type=template&id=4d29803e&scoped=true&"
import script from "./WBtnArchive.vue?vue&type=script&lang=js&"
export * from "./WBtnArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29803e",
  null
  
)

export default component.exports